export const optionsList: Record<string, string[]> = {
    "initiate_login": ["method", "page_type"],
    "login": ["method", "page_type"],
    "icon_click": ["page_type", "button_name"],
    "call_support": [],
    "call_icon_click": ["page_type"],
    "refresh_icon_click": ["page_type"],
    "notification_icon_click": ["page_type"],
    "my_orders_icon_click": ["page_type"],
    "cart_icon_click": ["page_type"],
    "more_icon_click": ["page_type"],
    "footer_home_icon_click": ["page-type"],
    "view_notification_list": ["page_type", "section_name"],
    "select_notification": ["page_type", "notification_name"],
    "page_view": ["page_type"],
    "otp_verification_failure": ["mobile_number"],
    "login_failure": ["mobile_number", "userId"],
    "view_shop_by_category": ["page_type", "selected_option"],
    "view_shop_by_brand": ["page_type", "selected_option"],
    "view_shop_by_pack": ["page_type", "selected_option"],
    "banner_view": ["banner_id", "banner_name", "banner_type"],
    "banner_swipe": ["banner_id", "banner_name", "banner_type"],
    "banner_click": ["banner_id", "banner_name", "banner_type"],
    "banner_play": ["banner_id", "banner_name", "banner_type"],
    "basket_view": ["page_type", "basket_name"],
    "view_all_product_click": ["page_type", "basket_name", "section_name"],
    "see_all_products_hotselling": ["page_type", "section_name"],
    "see_all_products_newlaunches": ["page_type", "section_name"],
    "see_all_products_orderednearyou": ["page_type", "section_name"],
    "see_all_products_youregularlyorder": ["page_type", "section_name"],
    "view_all_promo_click": ["page_type", "basket_name", "basket_id"],
    "search_found": ["searched_text"],
    "search_not_found": ["searched_text"],
    "voice_search_found": ["searched_text"],
    "voice_search_not_found": ["searched_text"],
    "switch_order_status_filter": ["page_type", "selected_option", "section_name"],
    "support_complaint_submit": ["page_type", "priority", "complaint_type",],
    "change_password_submit": ["page_type"],
    "logout": ["page_type"],
    "reset_cart": ["page_type"],
    "add_more_from_cart": ["page_type"],
    "home_icon_click": ["page_type"]
};

export const eventList = [
    ...Object.keys(optionsList)
];